// @flow
import React from 'react'
import { connect } from 'react-redux'
// $FlowFixMe
import { formValueSelector } from 'redux-form'
// $FlowFixMe
import { Elements, injectStripe } from 'react-stripe-elements'
import { stripeRequest, showLoader, stripeError, addPaymentIntent } from 'src/ducks/stripe'
import { updateBooking } from 'src/ducks/booking'

import type { Props } from './types'
import SecureRoomForm from './SecureRoomForm'
import { PAYMENT_ERROR_MSG, ALLOWED_ERROR_CODES } from 'src/helpers/constants'
import handleError from '../../helpers/handle-errors'

const selector = formValueSelector('secureRoom')

const mapStateToProps = (state, ownProps) => {
  const {
    booking,
    stripe: { isProcessing },
    form,
    router
  } = state

  const { location = {} } = router
  const { pathname = '' } = location
  const locationIdFromPath = pathname.includes('tccw') ? 'tccw' : 'tcoo'
  //pushing just to test the cause of failure

  const {
    match: {
      params: { locationId }
    }
  } = ownProps

  const { paymentPlan, isStudent, income, terms, isAffordable } = selector(
    state,
    'paymentPlan',
    'isStudent',
    'income',
    'terms',
    'isAffordable'
  )
  const {
    bookingDeposit,
    bookingDepositEdited,
    adminFee,
    yourName,
    roomPrice,
    preferredFloor,
    allow_cash,
    digitalVerification,
    occupancyType,
    membership
  } = booking

  const newDeposit = booking.membership
    ? bookingDepositEdited
      ? bookingDeposit
      : membership.weeklyPrice * 1
    : 0

  return {
    booking,
    bookingDeposit: newDeposit,
    adminFee,
    paymentPlan,
    roomPrice,
    isStudent,
    income,
    isProcessing,
    allow_cash,
    digitalVerification,
    terms,
    isAffordable,
    occupancyType,
    bookingDepositEdited,
    formFull: form.secureRoom,
    locationId: locationId || locationIdFromPath,
    initialValues: {
      membership: booking.membership,
      paymentMethod: 'card',
      income: booking.income,
      isAffordable: booking.isAffordable,
      isStudent: booking.isStudent === true ? 'Yes' : booking.isStudent === false ? 'No' : '',
      paymentPlan: booking.paymentPlan,
      referralCode: booking.referralCode ? booking.referralCode : '',
      discovery: booking.discovery ? booking.discovery : '',
      member: booking.member,
      room: booking.room,
      allow_cash: allow_cash,
      digitalVerification,
      moveIn: booking.moveIn,
      bookingDeposit,
      bookingDepositEdited,
      adminFee,
      yourName,
      roomPrice,
      preferredFloor,
      occupancyType
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    showLoader() {
      dispatch(showLoader())
    },
    stripeError(error: any) {
      if (error.code && ALLOWED_ERROR_CODES.includes(error.code) && !!error.message) {
        dispatch(stripeError(error))
      } else {
        dispatch(stripeError({ message: PAYMENT_ERROR_MSG }))
      }
      handleError(error)
    },
    addPaymentIntent(paymentIntent) {
      const { id } = paymentIntent

      if (!!id) {
        dispatch(addPaymentIntent({ paymentIntent: { id } }))
      } else {
        dispatch(stripeError({ message: PAYMENT_ERROR_MSG }))
        handleError(new Error('Payment was not attempted for this user'))
      }
    },
    onSubmit(values) {
      const { stripe } = ownProps
      const {
        adminFee,
        bookingDeposit,
        bookingDepositEdited,
        paymentPlan,
        membership,
        member: { firstName, lastName }
      } = values

      let newDeposit = bookingDeposit

      let securityBond = 0

      if (paymentPlan === 'monthly_5_weeks_security') {
        newDeposit = membership
          ? bookingDepositEdited
            ? bookingDeposit
            : membership.weeklyPrice * 1
          : 0
        securityBond = membership.weeklyPrice * 5
      } else {
        newDeposit = membership
          ? bookingDepositEdited
            ? bookingDeposit
            : membership.weeklyPrice * 1
          : 0
        securityBond = membership.weeklyPrice * 2
      }
      const fee = adminFee ? parseInt(adminFee, 10) : 0
      const deposit = newDeposit ? parseInt(newDeposit, 10) : 0
      values.bookingDeposit = deposit
      values.isAffordable = values.isAffordable || true
      values.isStudent = values.isStudent === 'Yes'
      values.securityBond = securityBond

      if (values.paymentMethod === 'cash' || fee + deposit === 0) {
        dispatch(updateBooking(values))
        dispatch(stripeRequest({ token: '', booking: values, useStripe: false }))
      } else {
        stripe.createToken({ name: `${firstName} ${lastName}` }).then(({ token }) => {
          dispatch(updateBooking(values))
          dispatch(stripeRequest({ token, booking: values, useStripe: true }))
        })
      }
    }
  }
}

const ConnectedSecureRoomForm = injectStripe(
  // $FlowFixMe
  connect(mapStateToProps, mapDispatchToProps)(SecureRoomForm)
)

const SecureRoom = (props: Props) => (
  <Elements>
    <ConnectedSecureRoomForm {...props} />
  </Elements>
)

export default SecureRoom



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/index.js